export const APPLICATION_JSON = "application/json";
export const AUTHORIZATION = "Authorization";
export const CONTENT_TYPE = "Content-Type";
